<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('heading')">
      <h1 :class="b('title')">{{ $t("Настройки") }}</h1>
      <p :class="b('subtitle')">Верификация аккаунта и платежные реквизиты</p>
    </div>

    <SettingsTabs :class="b('tabs')" :tab="tab" @update:tab="tabChange" />

    <component :is="displayedComponent" />
  </div>
</template>
